<div id="actionButtonsContainer" class="flexRowContainer">
  <button mat-icon-button (click)="backToCase()" (keydown.enter)="backToCase()"
          aria-label="Back to case">
    <mat-icon class="material-symbols-outlined">arrow_back</mat-icon>
  </button>
</div>
<div id="startSignatureProcessContainer" class="flexColumnContainer">
  <p class="headline-small">{{ 'signatureProcess.title' | translate }}</p>
  <span id="startSignatureProcessCaseName" class="body-medium">{{ 'signatureProcess.case' | translate }}
    : {{ case.name }}</span>
  <span id="startSignatureProcessClientName" class="body-medium">{{ 'signatureProcess.client' | translate }}
    : {{ getFullClientName() }}</span>
  <div id="documentsToSignContainer" class="flexRowContainer inputContainer">
    <mat-expansion-panel class="flexColumnContainer"
                         [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title class="title-medium">
          <mat-icon class="material-symbols-outlined stepIcon">pending_actions</mat-icon>
          {{ 'signatureProcess.documentsToSign.title' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <p class="body-medium">{{ 'signatureProcess.documentsToSign.description' | translate }}</p>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'signatureProcess.documentsToSign.label' | translate }}</mat-label>
        <mat-select multiple [(ngModel)]="selectedDocuments">
          @for (document of documents; track document) {
            <mat-option [value]="document">
              {{ document.title }}
            </mat-option>
          }
          @if ((documents)?.length === 0) {
            <mat-option class="no-checkbox" disabled>
              <span
              class="body-medium">{{ 'signatureProcess.documentsToSign.emptyOption' | translate }}</span>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @for (document of selectedDocuments; track document) {
        <div class="flexRowContainer formCard">
          <div class="flexColumnContainer formInfo">
            <span class="body-large formTitle">{{ document.title }}</span>
          </div>
          <button class="deselectDocumentButton" mat-icon-button (click)="deselectDocument(document)"
                  (keydown.enter)="deselectDocument(document)"
                  aria-label="Deselect Document">
            <mat-icon class="material-icons-outlined">cancel</mat-icon>
          </button>
        </div>
      }
    </mat-expansion-panel>
  </div>
  <div id="actionsContainer" class="flexRowContainer inputContainer">
    <button
      [disabled]="(!selectedDocuments.length)"
      mat-flat-button
      (click)="startSignatureProcess()"
      (keydown.enter)="startSignatureProcess()"
    >
      {{ 'signatureProcess.actions.startSignatureProcess' | translate }}
    </button>
  </div>
</div>

